import { Box, Typography } from '@mui/material';
import { TOKEN_SFL } from '../../../lib/name-space';

export function Notice({ type }: { type: string }) {
  return (
    <Box
      mt="10px"
      ml={{ xs: '16px', md: '53.48px' }}
      mr={{ xs: '16px', md: '0px' }}
      sx={{
        '& .MuiTypography-root': {
          fontWeight: 300,
          fontSize: { xs: '9px', md: '10px' },
          lineHeight: '16px',
          letterSpacing: '-0.02em',
          color: '#5D5D5D',
        },
      }}
    >
      <Typography>* Total Amount Of Issue : Displays The Total Amount Of {type} Issued.</Typography>
      <Typography>
        * Total Supply : Displays The Number Of Tokens, Excluding Incineration, From The Total Amount Issued.
      </Typography>
      {type === TOKEN_SFL ? (
        <>
          <Typography>
            * Circulation Volume : Displays The Number Of Tokens That Can Be Distributed And Traded Between Markets And
            Holders.
          </Typography>
          <Typography>
            * The Amount Of Not Distributed : Indicate The Number Of Tokens That Are Included In The Issued Volume But
            Are Not Yet In Circulation And Cannot Be Traded.
          </Typography>
        </>
      ) : (
        <></>
      )}
    </Box>
  );
}
